<script type="text/javascript">
// 定义一些公共的属性和方法
//const remoteIp = "http://1.117.171.103:80";
const remoteIp = "";
//const liveIp = "http://43.129.193.192:8000/jhlive/";
const liveIp = "webrtc://play.cnks.org.cn/jhlive/";
//const remoteIp = "http://127.0.0.1:80";
//从右到左滚动
function srcollpic(x, y, z) {
  var speed = 30;
  var demo2 = document.getElementById(x);
  var demo1 = document.getElementById(y);
  var demo = document.getElementById(z);
  demo2.innerHTML = demo1.innerHTML;

  function Marquee() {
    if (demo2.offsetWidth - demo.scrollLeft <= 0)
      demo.scrollLeft -= demo1.offsetWidth;
    else {
      demo.scrollLeft++;
    }
  }
  var MyMar = setInterval(Marquee, speed);
  demo.onmouseover = function() {
    clearInterval(MyMar);
  };
  demo.onmouseout = function() {
    MyMar = setInterval(Marquee, speed);
  };
}
function isPhone() {
  var mobile = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return mobile != null;
}

function sortByTop(arr) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i].top == "1") {
      arr.slice(i, 1);
      arr.unshift(arr[i]);
      break;
    }
  }
  return arr;
}
function importAdminJs() {
  let script = document.createElement("script");
  // let xcityscript = document.createElement("script");
  let head = document.getElementsByTagName("head")[0];
  script.src = "/newmanager/static/js/xadmin.js";
  // xcityscript.src="/manager/static/js/xcity.js";
  head.appendChild(script);
  // head.appendChild(xcityscript);
}
function getCode(len) {
  var chars = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
  ];
  var nums = "";
  for (var i = 0; i < len; i++) {
    var id = parseInt(Math.random() * 62);
    nums += chars[id];
  }
  return nums;
}
// 暴露出这些属性和方法
export default {
  remoteIp,
  srcollpic,
  sortByTop,
  isPhone,
  importAdminJs,
  liveIp,
  getCode,
};
</script>
